export default {
  id: null,
  nome: null,
  empresaID: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/business/gedtagmodel.js